export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9335.c2ef159f.jpg";